import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import RootLayoutWrapper from '@layouts/RootLayoutWrapper'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { Outlet, RouteObject } from 'react-router'

const YourDirectReportsRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    element: (
      <RootLayoutWrapper>
        <Outlet />
      </RootLayoutWrapper>
    ),
    children: [
      {
        path: AppPaths.tenant.yourDirectReports(),
        element: (
          <StandardPageLayout
            maxWidth={1080}
            title={<T _str="Direct reports recognized" />}
            elementId="yourDirectReports">
            <Suspense fallback={<RouteLoading />}>
              <YourDirectReportsRoute />
            </Suspense>
          </StandardPageLayout>
        ),
      },
    ],
  },
]

export default routes
